module.exports = __webpack_public_path__ + "img/70690872.5ba78b07.png";